export default __webpack_public_path__ + "static/media/007-electricity.dfc4483a.svg";